import tableColumnsCache from "@/utils/tableColumnsCache"

const listVersion = 0
export const listName = 'sl.website.paginas'
export const listStorage = tableColumnsCache(listName, [
    {label: 'ID', name: 'id', active: true, sortable: true, ordering: 1},
    {label: 'Título', name: 'title', active: true, sortable: true, ordering: 2},
    {label: 'Código', name: 'page', active: true, sortable: true, ordering: 2},
    {label: 'Ativo', name: 'status', active: true, sortable: true, ordering: 3},
], listVersion)
